import { render, staticRenderFns } from "./UiDropDownNew.vue?vue&type=template&id=35b809a4&scoped=true"
import script from "./UiDropDownNew.vue?vue&type=script&lang=js"
export * from "./UiDropDownNew.vue?vue&type=script&lang=js"
import style0 from "./UiDropDownNew.vue?vue&type=style&index=0&id=35b809a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35b809a4",
  null
  
)

export default component.exports